import * as types from '../actions/action-types';

const INITIAL_STATE = {
    groupStatus: {
        status: null,
        subStatus: null
    },
    modalLeadCount: false,
    leadCount: 0,
    eventLoading: false,
    eventActionLoading: false,
    eventActionText: '',
    aaApprovers: [],
    aaRecommended: true,
    aaRequestModalActive: false,
    aaRequestMessage: null,
    aaStatus: 'Incomplete',
    aaTasks: [],
    aaApproveModalActive: false,
    approveModalActive: false,
    approvers: [],
    contract: '',
    currentReviewerId: null,
    errorMessage: null,
    event: [],
    eventApproveReject: false,
    eventFiles: [],
    eventRecommended: true,
    eventReport: [],
    eventSaveSubmit: false,
    hasActions: false,
    hasAfterActionActions: false,
    id: null,
    mcrcUploadedFile: false,
    regionalUploadedFile: false,
    districtUploadedFile: false,
    name: null,
    notes: [],
    onsiteActivations: 0,
    parentSearchResults: [],
    prAccessible: false,
    prComplete: false,
    prInfo: null,
    prModal: false,
    prSaveSubmit: false,
    prStatus: null,
    purchaseError: null,
    rejectComments: null,
    rejectModalActive: false,
    requestModalActive: false,
    startDate: null,
    status: 'Incomplete',
    storedVendors: [],
    successMessage: null,
    tasks: [],
    updatedAt: null,
    updatedBy: null,
    userAction: null,
    userIsCreator: false,
    validTabOne: true,
    validTabTwo: true,
    vendorDropdown: [],
    selectedCategories: [],
    showEventRecommend: false,
    endDate: null,
    prloading: false,
    formSaved: true,
    approverSet: false
};

export const getEventStatus = state => state.status;
export const getEventLoading = state => state.eventLoading;
export const getPrLoading = state => state.prloading;

//Form action (Save, Submit, Reject, Approve, etc ...)
export const getEventActionLoading = state => state.eventActionLoading;
export const getEventActionText = state => state.eventActionText;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.CREATE_EVENT) {
        return {
            ...state,
            event: action.event
        };
    } else if (action.type === types.CREATE_EVENT_REPORT) {
        return {
            ...state,
            eventReport: action.eventReport
        };
    } else if (action.type === types.SET_EVENT_STATUS) {
        return {
            ...state,
            status: action.status
        };
    } else if (action.type === types.SET_EVENT_ID) {
        return {
            ...state,
            id: action.id
        };
    } else if (action.type === types.SET_EVENT_TASKS) {
        return {
            ...state,
            tasks: action.tasks
        };
    } else if (action.type === types.ADD_EVENT_TASK) {
        return {
            ...state,
            tasks: state.tasks.push(action.task)
        };
    } else if (action.type === types.SET_REJECT_COMMENTS) {
        return {
            ...state,
            rejectComments: action.rejectComments
        };
    } else if (action.type === types.SET_EVENT_START_DATE) {
        return {
            ...state,
            startDate: action.date
        };
    } else if (action.type === types.SET_EVENT_SUCCESS_MESSAGE) {
        return {
            ...state,
            successMessage: action.message
        };
    } else if (action.type === types.SET_EVENT_ERROR_MESSAGE) {
        return {
            ...state,
            errorMessage: action.message
        };
    } else if (action.type === types.SET_CURRENT_REVIEWER_ID) {
        return {
            ...state,
            currentReviewerId: action.id
        };
    } else if (action.type === types.SET_EVENT_ACTIONS) {
        return {
            ...state,
            hasActions: action.hasActions
        };
    } else if (action.type === types.SET_USER_IS_CREATOR) {
        return {
            ...state,
            userIsCreator: action.userIsCreator
        };
    } else if (action.type === types.SET_INVALID_TABS) {
        return {
            ...state,
            validTabOne: action.validObj.formOneValid,
            validTabTwo: action.validObj.formTwoValid
        };
    } else if (action.type === types.SET_EVENT_NAME) {
        return {
            ...state,
            name: action.name
        };
    } else if (action.type === types.SET_EVENT_REJECT_MODAL_ACTIVE) {
        return {
            ...state,
            rejectModalActive: action.bool
        };
    } else if (action.type === types.SET_EVENT_REQUEST_MODAL_ACTIVE) {
        return {
            ...state,
            requestModalActive: action.bool
        };
    } else if (action.type === types.SET_EVENT_APPROVE_MODAL_ACTIVE) {
        return {
            ...state,
            approveModalActive: action.bool
        };
    } else if (action.type === types.SET_AA_APPROVE_MODAL_ACTIVE) {
        return {
            ...state,
            aaApproveModalActive: action.bool
        };
    } else if (action.type === types.SET_EVENT_USER_ACTION) {
        return {
            ...state,
            userAction: action.action
        };
    } else if (action.type === types.SET_EVENT_AFTER_ACTION_MOD) {
        return {
            ...state,
            hasAfterActionActions: action.bool
        };
    } else if (action.type === types.SET_EVENT_APPROVERS) {
        return {
            ...state,
            approvers: action.approvers
        };
    } else if (action.type === types.SET_AA_APPROVERS) {
        return {
            ...state,
            aaApprovers: action.approvers
        };
    } else if (action.type === types.SET_AA_NOTES) {
        return {
            ...state,
            notes: action.notes
        };
    } else if (action.type === types.ADD_AA_NOTE) {
        return {
            ...state,
            notes: state.notes.concat([action.note])
        };
    } else if (action.type === types.SET_AA_STATUS) {
        return {
            ...state,
            aaStatus: action.status
        };
    } else if (action.type === types.SET_AA_TASKS) {
        return {
            ...state,
            aaTasks: action.tasks
        };
    } else if (action.type === types.SET_EVENT_SAVE_SUBMIT) {
        return {
            ...state,
            eventSaveSubmit: action.bool
        };
    } else if (action.type === types.SET_EVENT_APPROVE_REJECT) {
        return {
            ...state,
            eventApproveReject: action.bool
        };
    } else if (action.type === types.SET_EVENT_FILES) {
        return {
            ...state,
            eventFiles: action.files
        };
    } else if (action.type === types.UPDATE_ATTACHED_DOCUMENTS) {
        let eventFilesFilter = state.eventFiles.map(file => {
            if (file.id === action.data.id) {
                return action.data;
            }
            return file;
        });
        return {
            ...state,
            eventFiles: eventFilesFilter
        };
    } else if (action.type === types.REMOVE_DOCUMENT_SUCCESS) {
        let newArray = state.eventFiles.filter(item => item.id !== action.id);
        console.log(newArray);
        return {
            ...state,
            eventFiles: newArray
        };
    } else if (action.type === types.SET_PR_SAVE_SUBMIT) {
        return {
            ...state,
            prSaveSubmit: action.bool
        };
    } else if (action.type === types.SET_PR_ACCESSIBLE) {
        return {
            ...state,
            prAccessible: action.bool
        };
    } else if (action.type === types.SET_PR_STATUS) {
        return {
            ...state,
            prStatus: action.status
        };
    } else if (action.type === types.ADD_VENDOR_ITEM) {
        return {
            ...state,
            storedVendors: state.storedVendors.concat([action.vendor])
        };
    } else if (action.type === types.CLEAR_VENDOR_ITEMS) {
        return {
            ...state,
            storedVendors: []
        };
    } else if (action.type === types.SET_VENDORS_DROPDOWN) {
        return {
            ...state,
            vendorDropdown: action.status
        };
    } else if (action.type === types.STORE_PURCHASE_REQUEST) {
        return {
            ...state,
            prInfo: action.data
        };
    } else if (action.type === types.SET_PR_COMPLETE) {
        return {
            ...state,
            prComplete: action.bool
        };
    } else if (action.type === types.SET_CONTRACT) {
        return {
            ...state,
            contract: action.contract
        };
    } else if (action.type === types.SET_PARENT_SEARCH) {
        return {
            ...state,
            parentSearchResults: action.items
        };
    } else if (action.type === types.SET_PR_MODAL) {
        return {
            ...state,
            prModal: action.bool
        };
    } else if (action.type === types.SET_APPROVER_STATE) {
        return {
            ...state,
            approverSet: action.bool
        };
    } else if (action.type === types.SET_MCRC_UPLOADED_FILE) {
        return {
            ...state,
            mcrcUploadedFile: action.bool
        };
    } else if (action.type === types.SET_DISTRICT_UPLOADED_FILE) {
        return {
            ...state,
            districtUploadedFile: action.bool
        };
    } else if (action.type === types.SET_REGIONAL_UPLOADED_FILE) {
        return {
            ...state,
            regionalUploadedFile: action.bool
        };
    } else if (action.type === types.SET_ONSITE_ACTIVATIONS) {
        return {
            ...state,
            onsiteActivations: action.num
        };
    } else if (action.type === types.SET_AA_RECOMMENDED) {
        return {
            ...state,
            aaRecommended: action.bool
        };
    } else if (action.type === types.SET_EVENT_RECOMMENDED) {
        return {
            ...state,
            eventRecommended: action.bool
        };
    } else if (action.type === types.SET_AA_REQUEST_MODAL) {
        return {
            ...state,
            aaRequestModalActive: action.bool
        };
    } else if (action.type === types.SET_AA_REQUEST_MESSAGE) {
        return {
            ...state,
            aaRequestMessage: action.message
        };
    } else if (action.type === types.SET_SELECTED_CATEGORIES) {
        return {
            ...state,
            selectedCategories: action.categories
        };
    } else if (action.type === types.SET_SHOW_EVENT_RECOMMEND) {
        return {
            ...state,
            showEventRecommend: action.bool
        };
    } else if (action.type === types.SET_EVENT_END_DATE) {
        return {
            ...state,
            endDate: action.date
        };
    } else if (action.type === types.EVENT_LOADING) {
        return {
            ...state,
            eventLoading: true
        };
    } else if (action.type === types.EVENT_LOADING_SUCCESS) {
        return {
            ...state,
            eventLoading: false
        };
    } else if (action.type === types.EVENT_ACTION_LOADING) {
        return {
            ...state,
            eventActionLoading: true,
            eventActionText: action.eventActionText
        };
    } else if (action.type === types.EVENT_ACTION_SUCCESS) {
        return {
            ...state,
            eventActionLoading: false,
            eventActionText: ''
        };
    } else if (action.type === types.PR_LOADING) {
        return {
            ...state,
            prloading: true
        };
    } else if (action.type === types.PR_LOADING_SUCCESS) {
        return {
            ...state,
            prloading: false
        };
    } else if (action.type === types.TOGGLE_MODAL_LEAD_COUNT) {
        return {
            ...state,
            modalLeadCount: !state.modalLeadCount
        };
    } else if (action.type === types.LEAD_COUNT) {
        return {
            ...state,
            leadCount: action.leadCount
        };
    } else if (action.type === types.FORM_SAVED) {
        return {
            ...state,
            formSaved: action.saveValue
        };
    } else if (action.type === types.EVENT_GROUP_STATUS) {
        return {
            ...state,
            groupStatus: {
                status: action.groupStatus.status,
                subStatus: action.groupStatus.subStatus
            }
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/event.js